import React from 'react'
import pluralize from 'pluralize'
import { InfoBox } from '../../../../../../views/components'
import WarningSvg from '../../../../../../theme/icons-v2/Controls/Warning.svg'
import styles from './TerminationWarning.module.scss'
interface TerminationWarningProps {
  draftInvoices: number
  activeInvoices: number
  openActiveInvoices: () => void
  openDraftInvoices: () => void
}

const invoiceLink = (count: number, label: string, onClick: () => void) => {
  return (
    <button type="button" className={styles.link} onClick={() => onClick()}>
      {count} {label} {pluralize('invoice', count)}
    </button>
  )
}

const TerminationWarning = ({
  draftInvoices,
  activeInvoices,
  openActiveInvoices,
  openDraftInvoices,
}: TerminationWarningProps) => {
  const links = [
    draftInvoices > 0 ? invoiceLink(draftInvoices, 'draft', openDraftInvoices) : null,
    activeInvoices > 0 ? invoiceLink(activeInvoices, 'outstanding', openActiveInvoices) : null,
  ].filter(Boolean)

  if (links.length === 0) {
    return null
  }

  const total = draftInvoices + activeInvoices

  return (
    <InfoBox type="error" className={styles.root}>
      <header>
        <img src={WarningSvg} alt="Warning" />
        <p>
          There {pluralize('is', total)}{' '}
          {links.map((link, i) => (
            <React.Fragment key={i}>
              {i > 0 && ' and '}
              {link}
            </React.Fragment>
          ))}{' '}
          associated with this lease. They will <b>not be deleted</b> upon termination.
        </p>
      </header>
    </InfoBox>
  )
}

export default TerminationWarning
